import styled from 'styled-components';

export const ExpandWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  border-radius: 7px;
  /* border: 1px solid #e2e2e2; */
  background: #edf0f5;
  transition: 0.4s ease-in-out all;
  overflow-x: hidden;
  overflow-y: visible;

  ${({ isExpanded }) =>
    isExpanded &&
    `
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
  `}
`;

export const ExpandHeader = styled.div`
  width: calc(100% - 30px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border-bottom: 1px solid rgba(196, 196, 196, 0.5); */
  padding: 16px 15px 0;
  /* height: 51px; */

  h4 {
    color: #616161;
    font-size: 20px;
    font-weight: 600;
  }

  .file-count {
    display: flex;
    margin-right: 28px;

    p {
      color: #616161;
      text-align: center;
      leading-trim: both;

      font-size: 14px;
      font-weight: 500;
    }
  }
`;

export const ExpandBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 18px 15px;

  label {
    margin: 0;
  }

  .actions {
    width: calc(100% - 30px);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const TableWrapper = styled.div`
  width: calc(100% - 20px);
  position: relative;
  overflow: scroll;
  margin-top: 18px;
  min-height: calc(100vh - 730px);
  max-height: calc(100vh - 680px);
  zoom: ${({ zoom }) => zoom}%;

  ${({ isExpanded }) =>
    isExpanded &&
    `
max-height: calc(100vh - 100px);
height: calc(100vh - 150px);
`}
`;

export const ExpandTableStyle = styled.table`
  width: 100%;
  overflow: scroll;
  border-spacing: 0;

  ${({ isExpanded }) => isExpanded && 'height: calc(100vh - 150px);'}

  thead {
    td {
      background: #f4f4f4;
      text-align: center;
      color: #242424;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px; /* 150% */
    }
  }

  td {
    min-width: 156px;
    height: 19px;
    border: 0.5px solid rgba(196, 196, 196, 0.5);
    color: #242424;
    font-size: 16px;
    font-weight: 600;
    padding: 15px 10px;

    &:first-child {
      min-width: 60px;
      max-width: 60px;
      background: #f4f4f4;
      text-align: center;
    }
  }
`;
